module.exports = __webpack_public_path__ + "img/medalla.d734a095.svg";